export default __webpack_public_path__ + "assets/images/aistudio/empty_state/a782395ad59c24bbd0a2a7f088219f9e.png";